import 'jquery';

/**
 * handle existing payments
 */
(function ($) {

  var input = $(':input[data-payment-target]'),
    inputs = $(':input[data-payment-source]');

  if (!input.length) {
    return false;
  }

  // if someone changes our selection, put its value into our hidden field
  inputs.on('change', function () {
    input.val($(this).val());
    inputs.removeAttr('checked');
    $(this).attr('checked', 'checked');
  });

  // put our preselected value into our hidden field
  input.val(inputs.filter(':checked').val());

}(jQuery));
